import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Popover, Box, Typography, Button, Grid, Skeleton, useMediaQuery, IconButton } from '@mui/material';
import restype from "../../assets/restype.png";
import { updateActivityDuration, updateReservationType, updateTime } from '../../store/slice/Activity.slice';
import { IMG_BASE_URL } from '../../utils/utils';
import { useTheme } from '@emotion/react';
import ShowMoreLessText from '../horecaWidget/ShowMoreLessText';
import AddShoppingCartTwoToneIcon from '@mui/icons-material/AddShoppingCartTwoTone';
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import AddCircleTwoToneIcon from '@mui/icons-material/AddCircleTwoTone';
import useActivityWidget from '../../hooks/useActivityWidget';
import CircularProgress from '@mui/material/CircularProgress';
const ReservationType = ({ Ref, isOpen, handleClose, isLoading }) => {
  const theme=useTheme()
  const matchesSm=useMediaQuery('sm')
  const [showMore, setShowMore] = useState(false);
  const {  reservType,ActivityData } = useSelector((store) => store?.Activity);
  const [isImageValid, setIsImageValid] = useState(true); // Track image validity
  const dispatch = useDispatch();
  const resetRelatedFields=()=>{
    dispatch(updateTime(''))
    dispatch(updateActivityDuration(''))
    
  }
  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
  
      PaperProps={{
        sx: {
          width: matchesSm ? "93%" : "100%",
          maxWidth: "850px",
          
        },
      }}
    >
      {
isLoading ? <Box sx={{display:"flex",justifyContent:"center",alignItems:"center",height:"300px"}}>
  <CircularProgress color="inherit" /> 
  </Box>:
      <Box
        sx={{
          backgroundColor: theme?.resType?.bgColor,
          width: { xs: "100%", sm: "100%", md: "100%" }, // Responsive width
        // maxHeight:"450px",
          overflowY:'scroll',
          p: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent:'center',
          gap: "1rem",
       
        }}
      >

          {
            ActivityData.map((item, i) => (
              <Box
                key={i}
                sx={{
                  position:"relative",
                  display: 'flex',
                  minHeight:"150px",
                  flexDirection: { xs: 'column', sm: 'column', md: 'row' },
                  gap: '0.5rem',
                  backgroundColor: reservType?.name === item?.name
                  ? theme?.resType?.itemBgActive
                  : theme?.resType?.itemBgColor,
                  border: `1px solid ${theme?.resType?.borderColor}`,
                  p: 1,
                  borderRadius: '8px',
                  cursor: 'pointer',
                  width: '100%',
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: "0px 6px 18px rgba(0,0,0,0.2)",
                  },
                }}
              
              >
                <Grid container>
                  {item?.image && isImageValid && <Grid item xs={12} sm={4} md={4}>
                    <Box
                     sx={{
                      width: "100%",
                      maxHeight:200,
                      height:'100%',
                      display: "flex",
                      justifyContent: "center",
                      borderRadius: "12px",
                      overflow: "hidden", // To ensure image doesn't overflow
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Subtle shadow around image
                      "&:hover img": {
                        transform: "scale(1.05)", // Slight zoom effect on hover
                        transition: "transform 0.3s ease-in-out"
                      }
                              }}
                 
                    >
                      <img
                        src={item?.image}
                        alt="activity-type-img"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                          transition: "transform 0.3s ease-in-out",
                       
                        }}
                        onLoad={() => {
                          setIsImageValid(true); // Confirm valid image
                        }}
                        onError={(error) => {
                          setIsImageValid(false); // Mark image as invalid
                        }}
                      />
                    </Box>
                  </Grid>}
                  <Grid item xs={12} sm={8} md={item?.image && isImageValid  ? 8 : 12}>
                    <Box sx={{ p: 1, width: '100%' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <Typography
                          sx={{
                            color: reservType?.name === item?.name ? '#FEF5D8' : '#000000',
                            fontSize: '14px',
                            fontWeight: '600',
                          }}
                        >
                          {item?.languages?.find((prod)=>prod.fieldname == 'name')?.data || item?.name}
                        </Typography>
              
                      </Box>
                      {item?.languages?.find((prod)=>prod.fieldname == 'info')?.data &&
                           <ShowMoreLessText
                          text={item?.languages?.find((prod)=>prod.fieldname == 'info')?.data}
                          setIsShowMore={() => setShowMore(!showMore)}
                          isShowMore={showMore}
                          style={{
                            fontSize:"1rem",
                            color:
                            reservType?.name === item?.name
                              ? theme?.resType?.textColorActive
                              : theme?.resType?.itemTextColor,
                          }}
                        />
                        
                      }
                      <Box sx={{ position:"absolute",bottom:10,right:10}}>
                        <IconButton
                          //variant="contained"
                          size={"small"}
                          sx={{
                            backgroundColor:
                              reservType?.name === item?.name
                                ? theme?.resType?.chooseBgActive
                                : theme?.resType?.chooseBg,
                            color:
                              reservType?.name === item?.name
                                ? theme?.resType?.chooseTextActive
                                : theme?.resType?.chooseText,
                            "&:hover": {
                              backgroundColor: theme?.resType?.chooseBgHover,
                              color: theme?.resType?.chooseTextHover,
                            },
                            // // width: '60px',
                            // // height: '30px',
                            // fontSize: '10px',
                             borderRadius: '5px',
                          }}
                          onClick={() => {
                            localStorage?.setItem('idreservation',item?.idreservationtype)
                            dispatch(updateReservationType(item));
                            resetRelatedFields()
                            handleClose();
                          }}
                        >
                          <AddCircleTwoToneIcon />
                       
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ))
                        }
    
      </Box>
}
    </Popover>

  );
};

export default ReservationType;
